var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatApp"},[_c('ChatLeft'),_c('ChatRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }